(() => {
  'use strict';
  const selector = '[data-polygons-country-picker]';
  document.addEventListener('toggle', event => {
    const picker = event.target;
    if (!picker.matches?.(selector) || !picker.open) return;
    for (const other of document.querySelectorAll(`${selector}[open]`)) {
      if (other !== picker) other.open = false;
    }
  }, true);
  document.addEventListener('click', event => {
    for (const picker of document.querySelectorAll(`${selector}[open]`)) {
      if (!picker.contains(event.target)) picker.open = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    for (const picker of document.querySelectorAll(`${selector}[open]`)) {
      const restoreFocus = picker.contains(document.activeElement);
      picker.open = false;
      if (restoreFocus) {
        event.preventDefault();
        picker.querySelector('summary')?.focus();
      }
    }
  });
})();
